<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Allot Credit')"
          icon="mdi-account-tie"
          class="px-3 py-3"
        >
          <v-card class="py-0 my-2" elevation="1" color="blue lighten-5 d-none d-md-flex">
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="12" xs="12" sm="12">
                  <v-row>
                    <v-col cols="12" md="4">{{$i18n.t('Vendor')}}</v-col>
                    <v-col cols="12" md="2">{{$i18n.t('Credit Allowed')}}</v-col>
                    <v-col cols="12" md="4">{{$i18n.t('Currency')}}</v-col>
                    <v-col cols="12" md="2">{{$i18n.t('Fuel Limit')}}</v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card v-for="alotc in credit" :key="alotc.vendor_id" class="py-0 my-2" elevation="1">
            <v-card class="py-0 my-2" elevation="1">
              <v-card-text class="py-0">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" justify="center">
                    <v-row justify="center">
                      <v-col cols="12" md="4">{{alotc.vendorName}}</v-col>
                      <v-col cols="12" md="2">
                        <v-checkbox v-model="alotc.creditAllowed" :label="$i18n.t('')" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <z-currency-select class="purple-input" v-model="alotc.fuelLimit.currency" />
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field
                          :label="$i18n.t('Fuel Credit')"
                          class="purple-input"
                          v-model="alotc.fuelLimit.limit"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card>

          <v-col cols="12" class="text-right">
            <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  url = "/api/fuel/credit/all";
  credit = [
    {
      fuelLimit: {
        currency: "",
        limit: "",
      },
    },
  ];

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.credit = await doGet(this.url);
      for (let i = 0; i < this.credit.length; i++) {
        if (this.credit[i].fuelLimit == undefined) {
          this.credit[i].fuelLimit = {};
        }
      }
    } catch (e) {
      common.setError(e.message);
    }
  }
  remove(_index) {
    this.credit.splice(_index, 1);
  }

  async save() {
    try {
      common.setLoading(true);
      await doPost("/api/fuel/credit/save", this.credit);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
